import React, { useEffect, useState } from 'react';
import axios from 'axios';

const IntroV2 = () => {
  const [abouts, setAbouts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const Url = process.env.REACT_APP_URL_DEV;

  useEffect(() => {
    axios
      .get(`${Url}/api/about/all`)
      .then((response) => {
        setAbouts(response.data.data);
        setLoading(false);
      })
      .catch((error) => {
        setError('Erreur lors du chargement des données : ' + error.message);
        setLoading(false);
      });
  }, []);

  const removeHtmlTags = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || ' ';
  };

  if (loading) return <p></p>;
  if (error) return <p>{error}</p>;
  if (abouts.length === 0) return <p>Aucune donnée disponible.</p>;

  return (
    <div className="main-blog-area pd-top-80 pd-bottom-90">
      <div className="container">
        <div className="team-details-page">
          {abouts.map((item, i) => (
            <div className="row d-flex align-items-start " key={item.aboutId}>
              {i % 2 === 0 ? (
                <>
                  <div className="col-lg-7 align-self-center">
                    <div className="details">
                      <h3>{item.aboutTitre}</h3>
                      <span
                        className="text-justify d-block"
                        style={{ textAlign: 'justify', display: 'block' }}
                      >
                        {removeHtmlTags(item.aboutDescription)}
                      </span>
                    </div>
                  </div>
                  <div className="col-lg-5">
                    <div className="thumb">
                      <img
                        src={`${Url}/images/${item.aboutImage}`}
                        alt={item.aboutTitre}
                      />
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="col-lg-5">
                    <div className="thumb">
                      <img
                        src={`${Url}/images/${item.aboutImage}`}
                        alt={item.aboutTitre}
                      />
                    </div>
                  </div>
                  <div className="col-lg-7 align-self-center mt-5 mt-lg-0">
                    <div className="details">
                      <h3>{item.aboutTitre}</h3>
                      <span
                        className="text-justify d-block"
                        style={{ textAlign: 'justify', display: 'block' }}
                      >
                        {removeHtmlTags(item.aboutDescription)}
                      </span>
                    </div>
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default IntroV2;
